
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarContainer, GridToolbarExport
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from "@mui/icons-material/Edit";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LinearIndeterminate from "../CommonComponents/Progress";
import Button from "@mui/material/Button";
import {
    Avatar,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Link, ListItemIcon, ListItemText,
    Tooltip
} from "@mui/material";

// App Imports

import {
    newMasterContract, getContractsByType,
} from "./ContractClient";
import {changeContract} from "../Contract/contractSlice";
import ContractSectionMenu from "../Menus/ContractSectionMenu";
import CustomFooter from "../CommonComponents/GridCustomFooter";
import ContractDrawer from "./ContractDrawer";
import {changeContractDrilldown} from "../ContractDrilldown/contractDrilldownSlice";
import {changeContractSection} from "../ContractSection/contractSectionSlice";
import {useNavigate} from "react-router-dom";
import {ContractSearchGridColumns} from "../WorkQueue/Contracts/ContractSearchGridColumns";
import {ContractGridColumns} from "./ContractGridColumns";
import Badge from "@mui/material/Badge";


// main function
export default function ContractGrid({onCsList, onCsfList, onCdpList, onCdpvList, onCdpvfList, onVocabularyList, onMarketList}) {

    // ****************** BEGIN STATES ****************************

    // these are my states, which must be within the function
    const [contracts, setContracts] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [submitting, setSubmitting] = useState(false);

    const [contractIdX, setContractIdX] = React.useState([]);
    const [contractMcode, setContractMcode] = React.useState([]);
    const [contractName, setContractName] = React.useState([]);
    const [contractDescription, setContractDescription] = React.useState([]);

    const [showControls, setShowControls] = useState(true);

    const [showCRUD, setShowCRUD] = useState(true);
    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractId = useSelector((state) => state.contractSlc.value.id);
    const selectorContractAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorContractId2 = useSelector((state) => state.contractSlc.value.cloneId);
    const selectorContractName = useSelector((state) => state.contractSlc.value.name);
    const selectorModule = useSelector((state) => state.contractSlc.value.module);

    const selectorPage =        useSelector(state => state.contractSlc.value.page);
    const selectorPageSize = useSelector(state => state.contractSlc.value.pageSize);
    const selectorContractIdGeneratedFromAbstract = useSelector((state) => state.contractSlc.value.contractIdGeneratedFromAbstract);
    const hideActions = localStorage.getItem('hideActions') === "true";

    const [paginationModel, setPaginationModel] =
        useState({
            page: selectorPage,
            pageSize: 50,
            rowsPerPageOptions: 50
        });

    const dispatchData = useDispatch();

    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorCGridRefresh = useSelector(state => state.contractSlc.value.cGridRefresh

    );
    // ********************** END STORE ********************************


    // ****************** BEGIN USER ****************************

    const currentUserId = localStorage.getItem('userId');
    const currentUserName = localStorage.getItem('userName');
    // const currentUserContractType = useSelector((state) => state.userProfileSlc.value.userContractType);
    const currentUserDepartment = localStorage.getItem('department');

    // ****************** END USER ****************************

    // ****************** BEGIN FETCH ****************************

// function fetchContracts() {
// console.log("fetchContracts triggered");
//
//     getContractsByType(selectorContractGridAPI)

//         .then(data => {
//             console.log(data);
//             // setContracts(data);
//             if (selectorContractGridAPI === "PartsAbstracts") {
//
//                 const sortedContracts = [...data].sort((a, b) => b.id - a.id);
//
//                 setContracts(sortedContracts);
// }
// else {           setContracts(data);}
//         })}

    const fetchContracts = React.useCallback(() => {
        console.log("fetchContracts triggered");

        return getContractsByType(selectorContractGridAPI)

            .then(data => {
                console.log("My fetched contract data");
                console.log(data);
                if (selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") {
                    setContracts([...data].sort((a, b) => b.id - a.id));
                } else {
                    setContracts(data);
                }
            });
    }, [selectorContractGridAPI]);


    useEffect(() => {
        fetchContracts();
    }, [fetchContracts]);

    useEffect(() => {
        if (!selectorCGridRefresh) return;

        fetchContracts().finally(() => {
            dispatchData(changeContract({ cGridRefresh: false }));
        });
    }, [selectorCGridRefresh, fetchContracts, dispatchData]);

//
//     useEffect(() => {
//     fetchContracts();
// }, [useSelector((state) => state.contractSlc.value.contractGridAPI)]);
//
//     useEffect(() => {
//         fetchContracts();
//         dispatchData(changeContract({cGridRefresh: false}));
//     }, [useSelector((state) => state.contractSlc.value.cGridRefresh)===true]);

    // ****************** END FETCH ****************************



    // ****************** BEGIN HANDLES *****************************

    const renderContracts = contracts => {
        if (contracts.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }
    const handlePaginationChange = (model) => {
        dispatchData(changeContract({page: model.page}));

        navigate(
            `${location.pathname}?page=${model.page}`,
            { replace: true }
        );
    };

    // ****************** END HANDLES *****************************

    // ****************** BEGIN CRUD ***********************************

    function handleAdd() {
        newMasterContract(selectorContractAPI).then(() => {
            {dispatchData(changeContract({
        cGridRefresh: true
            }))}

        }).catch(err => {
            console.log(err)})
        };



    const handleEdit = () => {
        dispatchData(changeContract({
            contractDrawerState: true,
            contractDrawerMode: "Edit"
            // ,residualsTabsVisible: true
            ,contractGridVisible: true
            ,contractDrilldownVisible: false
            ,contractSearchVisible: false
            ,contractConfigVisible: false
            // ,contractView: null
            // ,participationsTabsVisible: false
            // ,royaltiesTabsVisible: false
        }));
    }
    //
    // const removeContract = (selectorContractId, callback) => {
    //     deleteContract(selectorContractId).then(() => {
    //         setDeleteOpen(false);
    //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
    //     })
    // }
    //
    // const handleDeleteOpen = (selectContractId, selectContractMcode, selectContractName, selectContractDescription, rowFull) => {
    //     console.log("Here's the selected row data");
    //     console.log(rowFull);
    //     dispatchData(changeContract({id: selectContractId, mcode: selectContractMcode, name: selectContractName, description: selectContractDescription }));
    //     setDeleteOpen(true);
    // };
    //
    // const handleDeleteClose = () => {
    //     setDeleteOpen(false);
    // };
    //
    // const handleDeleteCancel = () => {
    //     setDeleteOpen(false);
    // };




        const navigate = useNavigate();


        // ****************** END CRUD ***********************************


    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectContractId,selectContractMcode, selectContractName, selectContractDescription, rowFull) => {
        setContractIdX(selectContractId);
        setContractName(selectContractName);
        setContractMcode(selectContractMcode);
        setContractDescription(selectContractDescription);
        dispatchData(changeContractDrilldown({id: rowFull.id, mcode: selectContractMcode, name: selectContractName, description: selectContractDescription}));
        console.log("Here's the row for drilldown");
        console.log(rowFull);
        console.log("Here's the mcode from the row");
        console.log(rowFull.mcode);
        console.log("Here's the contract id from the row");
        console.log(rowFull.id);
        // console.log("Here's the selectorDrilldownContractId, ", selectorDrilldownContractId);
        // getContractById(rowFull.id);
        // getContractById(contractIdX);
        dispatchData(changeContract({id: rowFull.id, mcode: rowFull.mcode, name: rowFull.name, description: rowFull.description,
            csCount: rowFull.csCount, csfCount: rowFull.csfCount, cdpCount: rowFull.cdpCount, cdpvCount: rowFull.cdpvCount, cdpvfCount: rowFull.cdpvfCount,
            vocabCount: rowFull.vocabCount, marketCount: rowFull.marketCount,
            contractGridVisible: false, contractDrawerState: false,contractDrilldownVisible: true,contractTabsVisible: false,
            module: selectorModule,
            contractView: "ContractDrilldown"}));
         dispatchData(changeContractSection({id: 0,nameShort: null}));
    }

    const handleRow = (selectContractId) => {
        console.log("Here's the row info");
        console.log(selectContractId);
    }

    // ****************** END DRILLDOWN ****************************



    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    {!hideActions &&
                    <Tooltip  enterDelay={1000} enterNextDelay={1000} title={"Add Contract"}>
                        <AddCircleOutlineIcon
                            sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                            fontSize="medium" color={'primary'}
                            onClick={() => handleAdd()}/>
                    </Tooltip>}

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    {!hideActions &&
                    <GridToolbarExport  />
                    }
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************



    return (


        <div style={{ height:800 , width: '100%' }}>

            {showCRUD && <ContractSectionMenu/>}
            {/*{useSelector((state) => state.contractDetailListSlc.value.csListDrawerState) && <ContractCsListDrawer/>}*/}
            {/*{useSelector((state) => state.contractDetailListSlc.value.csfListDrawerState) && <ContractCsfListDrawer/>}*/}
            {/*{useSelector((state) => state.contractDetailListSlc.value.cdpListDrawerState) && <ContractCdpListDrawer/>}*/}
            {/*{useSelector((state) => state.contractDetailListSlc.value.cdpvListDrawerState) && <ContractCdpvListDrawer/>}*/}
            {/*{useSelector((state) => state.contractDetailListSlc.value.cdpvfListDrawerState) && <ContractCdpvfListDrawer/>}*/}
            {/*{useSelector((state) => state.contractDetailListSlc.value.vocabularyListDrawerState) && <ContractVocabularyListDrawer/>}*/}
            {/*{useSelector((state) => state.contractDetailListSlc.value.marketListDrawerState) && <ContractMarketListDrawer/>}*/}
            {useSelector((state) => state.contractSlc.value.contractDrawerState)
            &&
            <ContractDrawer/>
            }

            {submitting && <LinearIndeterminate/>}
            {useSelector((state) => state.contractSlc.value.contractGridVisible)
                &&
                <DataGrid
                experimentalFeatures={{ newEditingApi: true }}

                aria-label={"Contracts"}
                rows={contracts}
                disableDensitySelector={true}
                disableColumnSelector={true}
                // columns={columns(fetchContracts)}
                columns={ContractGridColumns({
                    hideActions, contracts,selectorContractGridAPI, selectorContractId2,
                    dispatchData, navigate,setSubmitting,currentUserId, selectorContractAPI,
                    currentUserName,
                    currentUserDepartment, handleEdit, selectorContractId,
                    handleDrilldown,
                    onCsList,
                    onCsfList,
                    onCdpList,
                    onCdpvList,
                    onCdpvfList,
                    onVocabularyList,
                    onMarketList
                })}
                density={"compact"}
                // paginationModel={paginationModel}
                pagination
                page={selectorPage}
                pageSize={selectorPageSize}
                onPageChange={(page) =>
                    dispatchData(changeContract({ page }))
                }
                onPageSizeChange={(pageSize) =>
                    dispatchData(changeContract({ pageSize }))
                }
                rowsPerPageOptions={[50, 100, 200]}
                // initialState={{
                //     sorting: {
                //         sortModel: [
                //             { field: 'ordinalNumber', sort: 'desc' }
                //         ],
                //     },
                // }}
                // onPaginationModelChange={handlePaginationChange}
                // pageSize={50}
                // rowsPerPageOptions={[50]}
                rowKey={contract => contract.id}
                components={{
                    Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />
            }
        </div>

    );

}

